import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '第三届重庆青少年科幻征文大赛';
const baseUrl = '0610KHZW';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/welcome`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'welcome',
      name: `${baseUrl}-welcome`,
      component: () => import('./pages/Welcome.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        keepPosition: true,
      },
    },
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        keepPosition: true,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        keepPosition: true,
      },
    },
    // {
    //   path: 'user',
    //   name: `${baseUrl}-user`,
    //   component: () => import('./pages/User.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 1,
    //     keepPosition: true,
    //   },
    // },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'search',
      name: `${baseUrl}-search`,
      component: () => import('./pages/SearchResult.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'signUp',
      name: `${baseUrl}-signUp`,
      component: () => import('./pages/SignUp.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
  ],
};

export default route;
